import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError } from "rxjs";
import { EnvironmentService } from "../../api";
import { AuthenticationRouteDefs } from "../../features/authentication/routing/AuthenticationRouteDefs";
import { Session } from "../util/Session";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  public static errorCount = 0;
  public static API_OFFLINE = signal(false);
  public static countdown = signal(0);
  router = inject(Router);
  env = inject(EnvironmentService);
  private isCooldownActive = false;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          window.location.pathname.includes(AuthenticationRouteDefs.FEATURE_PATH) ||
          window.location.pathname.includes("/rechtliches/")
        ) {
          return throwError(() => error);
        }

        HttpErrorInterceptor.errorCount++;

        if (error.name.includes("HttpErrorResponse") && error.message.includes("v1/environment/test")) {
          HttpErrorInterceptor.API_OFFLINE.set(true);
          HttpErrorInterceptor.errorCount = 0;
        }

        if (HttpErrorInterceptor.errorCount >= 3 && !HttpErrorInterceptor.API_OFFLINE() && !this.isCooldownActive) {
          this.checkAPIOffline();
        }

        //Notifier.fromApiError(error);
        if (Session.getAuthToken() == null) {
          this.router.navigate([AuthenticationRouteDefs.getFQRMissingNotice()]);
        }

        if (error.status === 401) {
          Session.clearAuthToken();
          this.router.navigate([AuthenticationRouteDefs.getFQRMissingNotice()]);
        }

        return throwError(() => error);
      }),
    );
  }

  checkAPIOffline() {
    this.isCooldownActive = true;
    HttpErrorInterceptor.countdown.set(5);
    const interval = setInterval(() => {
      const currentCountdown = HttpErrorInterceptor.countdown();
      if (currentCountdown > 0) {
        HttpErrorInterceptor.countdown.set(currentCountdown - 1);
      } else {
        clearInterval(interval);
        this.isCooldownActive = false;
      }
    }, 1000);

    this.env.test().subscribe({
      next: (response) => {
        this.isCooldownActive = false;
        HttpErrorInterceptor.API_OFFLINE.set(false);
        HttpErrorInterceptor.errorCount = 0;
      },
      error: (error) => {
        // Reset cooldown after 5 seconds even if there's an error
        setTimeout(() => {
          this.isCooldownActive = false;
          this.checkAPIOffline();
        }, 5000);
      },
    });
  }
}
